import { ATIVO_TIPO } from '@investirapri/financa.js/lib/enums';

import {
  ATIVO_DISPLAY_MODE,
  isFundoDisplayMode,
  isFundoNaoListadoDisplayMode,
  isNegociadoEmBolsaDisplayMode,
  isRendaFixaDisplayMode
} from '../../../../components/organisms/ativoDisplayMode';

export const ATIVO_OVERVIEW_SECTION = {
  rentabilidade: 'rentabilidade',
  cotacao: 'cotacao',
  patrimonio: 'patrimonio',
  consistencia: 'consistencia',
  metricasRisco: 'metricasRisco',
  graphs: 'graphs',
  imoveis: 'imoveis'
};

const wDefaultSections = {
  gestorAdministrador: false,
  rentabilidade: false,
  cotacao: true,
  patrimonio: false,
  consistencia: false,
  metricasRisco: false,
  graphs: true,
  imoveis: false
};

const wFundoSections = {
  ...wDefaultSections,
  gestorAdministrador: true,
  rentabilidade: true,
  patrimonio: true,
  consistencia: true,
  metricasRisco: true
};

const wBolsaSections = {
  ...wDefaultSections,
  rentabilidade: true,
  patrimonio: true,
  consistencia: true,
  metricasRisco: true
};

const wRentabilidadeRiscoSections = {
  ...wDefaultSections,
  rentabilidade: true,
  metricasRisco: true
};

const wDerivativoSections = {
  ...wDefaultSections,
  metricasRisco: true
};

const wDefaultSectionOrder = [ATIVO_OVERVIEW_SECTION.cotacao, ATIVO_OVERVIEW_SECTION.graphs];

const wFundoSectionOrder = [
  ATIVO_OVERVIEW_SECTION.rentabilidade,
  ATIVO_OVERVIEW_SECTION.consistencia,
  ATIVO_OVERVIEW_SECTION.cotacao,
  ATIVO_OVERVIEW_SECTION.metricasRisco,
  ATIVO_OVERVIEW_SECTION.patrimonio,
  ATIVO_OVERVIEW_SECTION.graphs
];

const wFundoListadoSectionOrder = [
  ATIVO_OVERVIEW_SECTION.cotacao,
  ATIVO_OVERVIEW_SECTION.rentabilidade,
  ATIVO_OVERVIEW_SECTION.consistencia,
  ATIVO_OVERVIEW_SECTION.patrimonio,
  ATIVO_OVERVIEW_SECTION.imoveis,
  ATIVO_OVERVIEW_SECTION.metricasRisco,
  ATIVO_OVERVIEW_SECTION.graphs
];

const wBolsaSectionOrder = [
  ATIVO_OVERVIEW_SECTION.cotacao,
  ATIVO_OVERVIEW_SECTION.rentabilidade,
  ATIVO_OVERVIEW_SECTION.consistencia,
  ATIVO_OVERVIEW_SECTION.metricasRisco,
  ATIVO_OVERVIEW_SECTION.patrimonio,
  ATIVO_OVERVIEW_SECTION.graphs
];

const wRendaFixaSectionOrder = [
  ATIVO_OVERVIEW_SECTION.rentabilidade,
  ATIVO_OVERVIEW_SECTION.cotacao,
  ATIVO_OVERVIEW_SECTION.metricasRisco,
  ATIVO_OVERVIEW_SECTION.graphs
];

const wPrevidenciaSectionOrder = [
  ATIVO_OVERVIEW_SECTION.rentabilidade,
  ATIVO_OVERVIEW_SECTION.metricasRisco,
  ATIVO_OVERVIEW_SECTION.cotacao,
  ATIVO_OVERVIEW_SECTION.graphs
];

const wCriptoSectionOrder = [
  ATIVO_OVERVIEW_SECTION.cotacao,
  ATIVO_OVERVIEW_SECTION.rentabilidade,
  ATIVO_OVERVIEW_SECTION.metricasRisco,
  ATIVO_OVERVIEW_SECTION.graphs
];

const wDerivativoSectionOrder = [
  ATIVO_OVERVIEW_SECTION.cotacao,
  ATIVO_OVERVIEW_SECTION.metricasRisco,
  ATIVO_OVERVIEW_SECTION.graphs
];

/**
 * Retorna as seções aplicáveis ao overview conforme a apresentação do ativo.
 *
 * @param {string} pDisplayMode Modo de apresentação do ativo.
 * @param {Object} pAtivo Dados cadastrais do ativo.
 * @returns {Object}
 */
export function getAtivoOverviewSections(pDisplayMode, pAtivo = {}) {
  if (isFundoDisplayMode(pDisplayMode)) {
    const xShowImoveis =
      !isFundoNaoListadoDisplayMode(pDisplayMode) && pAtivo.ativo_tipo_id === ATIVO_TIPO.CTII.id;

    return {
      ...wFundoSections,
      imoveis: xShowImoveis
    };
  }

  if (isRendaFixaDisplayMode(pDisplayMode)) {
    return wRentabilidadeRiscoSections;
  }

  if (isNegociadoEmBolsaDisplayMode(pDisplayMode)) {
    return wBolsaSections;
  }

  if (
    pDisplayMode === ATIVO_DISPLAY_MODE.previdencia ||
    pDisplayMode === ATIVO_DISPLAY_MODE.cripto
  ) {
    return wRentabilidadeRiscoSections;
  }

  if (pDisplayMode === ATIVO_DISPLAY_MODE.derivativo) {
    return wDerivativoSections;
  }

  return wDefaultSections;
}

/**
 * Retorna a ordem das seções analíticas aplicável à apresentação do ativo.
 *
 * @param {string} pDisplayMode Modo de apresentação do ativo.
 * @returns {string[]}
 */
export function getAtivoOverviewSectionOrder(pDisplayMode) {
  if (pDisplayMode === ATIVO_DISPLAY_MODE.fundo_listado) {
    return wFundoListadoSectionOrder;
  }

  if (isFundoDisplayMode(pDisplayMode)) {
    return wFundoSectionOrder;
  }

  if (isRendaFixaDisplayMode(pDisplayMode)) {
    return wRendaFixaSectionOrder;
  }

  if (pDisplayMode === ATIVO_DISPLAY_MODE.bolsa) {
    return wBolsaSectionOrder;
  }

  if (pDisplayMode === ATIVO_DISPLAY_MODE.previdencia) {
    return wPrevidenciaSectionOrder;
  }

  if (pDisplayMode === ATIVO_DISPLAY_MODE.cripto) {
    return wCriptoSectionOrder;
  }

  if (pDisplayMode === ATIVO_DISPLAY_MODE.derivativo) {
    return wDerivativoSectionOrder;
  }

  return wDefaultSectionOrder;
}
